export const CREATE_JOB_YARN_ISSUE = 'CREATE_JOB_YARN_ISSUE';
export const GET_JOB_YARN_ISSUE = 'GET_JOB_YARN_ISSUE';
export const JOB_YARN_ISSUE_REQUEST = 'JOB_YARN_ISSUE_REQUEST';
export const JOB_YARN_ISSUE_REQUEST_SUCCESS = 'JOB_YARN_ISSUE_REQUEST_SUCCESS';
export const UPDATE_JOB_YARN_ISSUE = 'UPDATE_JOB_YARN_ISSUE';
export const DELETE_JOB_YARN_ISSUE = 'DELETE_JOB_YARN_ISSUE';
export const JOB_YARN_ISSUE_REQUEST_FAILURE = 'JOB_YARN_ISSUE_REQUEST_FAILURE';
export const GET_JOB_YARN_ISSUES_PAGE = 'GET_JOB_YARN_ISSUES_PAGE';
export const JOB_YARN_ISSUE_TRANSACTION_AVAILABLE_REQUEST = 'JOB_YARN_ISSUE_TRANSACTION_AVAILABLE_REQUEST';
export const JOB_YARN_ISSUE_TRANSACTION_AVAILABLE_REQUEST_FAILURE = 'JOB_YARN_ISSUE_TRANSACTION_AVAILABLE_REQUEST_FAILURE';
export const GET_JOB_YARN_ISSUE_AVAILABLE_TRANSACTIONS = 'GET_JOB_YARN_ISSUE_AVAILABLE_TRANSACTIONS';

